import React from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import createMarkup from '../../utils/create-markup'

const StyledFooter = styled('div')`
  display: none;

  ${themeGet('mediaQueries.md')} {
    display: block;
  }
`

const Footer = ({ footerHTML }: { footerHTML: string }) => {
  return footerHTML.length > 0 ? (
    <StyledFooter id="expr-ftr" className="experimental-footer">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={createMarkup(footerHTML)}
        id="pcln-global-footer"
        style={{ visibility: 'hidden' }}
      />
    </StyledFooter>
  ) : null
}

export default Footer
